import axiosInstance from '../utils/axiosInstance.js';
import { route_mqtt_led_flash, route_mqtt_reboot } from '../constants/BackendRoutes.js';
import { route_mqtt_set_endpoint } from '../constants/BackendRoutes.js';

/**
 * Flashes the LED by sending a request to the backend which in turn sends
 * an mqtt message
 * @param {string} deviceId id of the device
 */
export async function flashLED (deviceId) {
  try {
    // Fetch devices from your backend
    const url = `${route_mqtt_led_flash}/${deviceId}`;
    console.log(url);
    const response = await axiosInstance.post(url);
  } catch (error) {
    if ('status' in error)
    {
      console.log(`Backend not responding: ${error.status} error`);
    }
    else
    {
      console.error("Error flashing device LED:", error);
    }
  }
}


/**
 * Set a endpoint with value by sending a request to the backend with device id, endpoint and the
 * value to be set, which in turn sends a mqtt message
 * @param {string} deviceId id of the device
 * @param {integer} endpoint endpoint to be set with the value, must be in the DataEndpoint object
 * @param {integer} value value to be set for the endpoint
 */
export async function setEndpointValue (deviceId, endpoint, value) {
  try {
    // Fetch devices from your backend
    const url = `${route_mqtt_set_endpoint}/${deviceId}/${endpoint}/${value}`;
    console.log(url);
    const response = await axiosInstance.post(url);
  } catch (error) {
    if ('status' in error)
    {
      console.log(`Backend not responding: ${error.status} error`);
    }
    else
    {
      console.error("Error setting endpoint value:", error);
    }
  }
}

/**
 * Reboots the device by sending a request to the backend which in turn sends
 * an mqtt message
 * 
 * @param {string} deviceId id of the device
 */
export async function rebootDevice (deviceId) {
  try {
    // Fetch devices from your backend
    const url = `${route_mqtt_reboot}/${deviceId}`;
    console.log(url);
    const response = await axiosInstance.post(url);
  } catch (error) {
    if ('status' in error)
    {
      console.log(`Backend not responding: ${error.status} error`);
    }
    else
    {
      console.error("Error rebooting device:", error);
    }
  }
}
